import ConfigurationRoutes from "./ConfigurationRoutes";
export { ConfigurationRoutes };
